<template>
  <div class="text-xs-center">
    <v-flex>
      <v-flex><img height="35px" src="../../../assets/logo.png"/></v-flex>
      <h2 class="h2-header mt-2">{{ $t("pageHeader.crm") }}</h2>
      <GoogleLogin class="mt-3 mb-3" v-on:response="checkResponse"></GoogleLogin
      ><span class="mt-2 headline font-weight-light">OR</span>
      <v-text-field
        v-model="email"
        :error-messages="emailErrors"
        :label="$t('labels.email')"
      ></v-text-field>
      <v-text-field
        v-model="password"
        :append-icon="showPassword ? 'visibility_off' : 'visibility'"
        :type="showPassword ? 'text' : 'password'"
        :label="$t('labels.password')"
        v-on:keyup.enter="submit"
        :error-messages="passwordErrors"
        @input="$v.password.$touch()"
        counter="counter"
        @click:append="showPassword = !showPassword"
      ></v-text-field>
    </v-flex>
    <v-layout class="mt-4" row="row">
      <v-spacer></v-spacer>
      <v-btn @click="submit" color="primary" large="large">{{ $t("buttons.login") }}</v-btn>
    </v-layout>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import authService from "../service";
import GoogleLogin from "./GoogleLogin";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  name: "authentication-login",
  components: {
    GoogleLogin
  },
  data() {
    return {
      showPassword: false,
      email: null,
      password: null
    };
  },
  async created() {},
  methods: {
    ...mapActions("global", ["initOrganization", "setLoginDialog"]),
    checkResponse(response) {
      if (response.status === 400) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: "Invalid User"
          });
      } else {
        this.setLoginDialog(false)
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        this.$Progress.start();
        authService
          .authenticate({
            loginEmail: this.email,
            loginPassword: this.password
          })
          .then(response => {
            this.$Progress.finish();
            // set the organization id or ask for the selection
            console.log("response test user", response);
            this.checkResponse(response);
            this.setLoginDialog(false)
            // if (response.data && response.data.user && response.data.user.Organizations.length === 1) {
            //   return this.initOrganization(response.data.user.Organizations[0])
            //     .then(() => {
            //       this.$router.push({ path: '/' })
            //     })
            //     .catch((error) => {
            //       console.log(error)
            //     })
            // }
            //   if (response.data && response.data.user && response.data.user.Organizations.length > 1) {
            //     this.$router.push({
            //       path: '/login/organization',
            //       name: 'authentication-select-organization',
            //       params: {
            //         Organizations: response.data.user.Organizations,
            //       },
            //     })
            //   } else {
            //     this.$router.push({ path: '/newOrganization' })
            //   }
            // })
            // .catch((error) => {
            //   this.$Progress.finish()
            //   console.log(error)
            //   this.$swal('Invalid Login')
            // })
          })
          .catch(error => {
            this.$Progress.finish();
            console.log("error on ", error);
            this.$swal("Invalid Login", "Check email and password", "error");
          });
      }
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push("Email is not valid");
      if (!this.$v.email.required) errors.push("Email is required.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Password is required.");
      return errors;
    }
  },
  mixins: [validationMixin],
  validations: {
    email: {
      email,
      required
    },
    password: {
      required
    }
  }
};
</script>
